module.exports = __webpack_public_path__ + "media/images/new_culture/culture-index-chart-header-c4752b1b010ed5b0bc09f7779d314445.png";